import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';
import BASE_URL from '../config';

const Contact = () => {
  const [formData, setFormData] = useState({
    first_name: '', last_name: '', email: '', phone: '', subject: '', message: ''
  });
  const [status, setStatus] = useState(null); // { type: 'success'|'error', text: '' }
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);
    try {
      await axios.post(`${BASE_URL}/api/contact/`, {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
      });
      setStatus({ type: 'success', text: 'Thank you! Your message has been sent. We\'ll get back to you within 48 hours.' });
      setFormData({ first_name: '', last_name: '', email: '', phone: '', subject: '', message: '' });
    } catch (err) {
      const msg = err?.response?.data?.error || 'Something went wrong. Please try again.';
      setStatus({ type: 'error', text: msg });
    } finally {
      setSending(false);
    }
  };
  return (
    <div className="contact-page">
      <h1>Contact Us</h1>
      <p className="contact-page-sub">
        We'd love to hear from you — questions, orders, or just to say hello.
      </p>

      <div className="contact-grid">
        {/* Left column — Contact info */}
        <div>
          <h2 className="contact-section-title">Get in Touch</h2>
          <div className="contact-info-card">
            <div className="contact-info-item">
              <div className="contact-info-icon">🏢</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Company</div>
                <div className="contact-info-value">Vegbox GmbH</div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">📍</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Address</div>
                <div className="contact-info-value">
                  Dietlikonstrasse 29<br />
                  8600 Dübendorf, Switzerland
                </div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">📞</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Phone</div>
                <div className="contact-info-value">
                  <a href="tel:+41782224236">+41 78 222 42 36</a>
                </div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">✉️</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Email</div>
                <div className="contact-info-value">
                  <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>
                </div>
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-info-icon">🕐</div>
              <div className="contact-info-content">
                <div className="contact-info-label">Business Hours</div>
                <div className="contact-info-value">
                  Mon – Fri: 9:00 AM – 6:00 PM<br />
                  Sat – Sun: 10:00 AM – 4:00 PM
                </div>
              </div>
            </div>
          </div>

          <a
            href="https://www.instagram.com/vegbox.ch/?hl=en"
            target="_blank"
            rel="noreferrer"
            className="contact-social"
          >
            <span className="contact-social-icon">📷</span>
            Follow us on Instagram
          </a>
        </div>

        {/* Right column — Map */}
        <div>
          <h2 className="contact-section-title">Our Location</h2>
          <div className="contact-map-card">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2700.544!2d8.618!3d47.398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479aa0e5e7f5e7e7%3A0x1234567890abcdef!2sDietlikonstrasse%2029%2C%208600%20D%C3%BCbendorf%2C%20Switzerland!5e0!3m2!1sen!2sus!4v1234567890"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Vegbox Location"
            ></iframe>
          </div>
          <p className="contact-map-note">
            We're located in the heart of Dübendorf, easily accessible by public transport and car.
          </p>
        </div>
      </div>

      {/* Contact form */}
      <div className="contact-form-section">
        <h2>Send Us a Message</h2>
        <p className="contact-form-sub">Fill out the form below and we'll get back to you shortly.</p>

        <div className="contact-form-card">
          <form onSubmit={handleSubmit}>
            {status && (
              <div className={`contact-form-status ${status.type}`}>
                {status.type === 'success' ? '✅ ' : '⚠️ '}{status.text}
              </div>
            )}
            <div className="contact-form-row">
              <div className="contact-form-field">
                <label htmlFor="first_name">First Name</label>
                <input type="text" id="first_name" placeholder="John" required value={formData.first_name} onChange={handleChange} />
              </div>
              <div className="contact-form-field">
                <label htmlFor="last_name">Last Name</label>
                <input type="text" id="last_name" placeholder="Doe" required value={formData.last_name} onChange={handleChange} />
              </div>
            </div>
            <div className="contact-form-row">
              <div className="contact-form-field">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" placeholder="john@example.com" required value={formData.email} onChange={handleChange} />
              </div>
              <div className="contact-form-field">
                <label htmlFor="phone">Phone Number</label>
                <input type="tel" id="phone" placeholder="+41 ..." value={formData.phone} onChange={handleChange} />
              </div>
            </div>
            <div className="contact-form-row">
              <div className="contact-form-field full">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" placeholder="How can we help?" required value={formData.subject} onChange={handleChange} />
              </div>
            </div>
            <div className="contact-form-row">
              <div className="contact-form-field full">
                <label htmlFor="message">Message</label>
                <textarea id="message" placeholder="Write your message here..." required value={formData.message} onChange={handleChange}></textarea>
              </div>
            </div>
            <button type="submit" className="contact-submit-btn" disabled={sending}>
              {sending ? 'Sending…' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;